import styled from '@emotion/styled'

export const SortingPropertySelectWrapper = styled.div`
  width: 260px;
`
